import config from "./index";
import router from '../routers/index';

module.exports = {
  setTitle: function (name) {
    document.title = name;
  },
  requestParam: function (data) {
    let $route = router.app.$route;

    data = data || {};

    data.page = $route.query['page'] || 1;
    data.keyword = $route.query['keyword'] || '';
    data.per_page = data.per_page || config.perPage;

    if (!data.keyword.length) {
      delete data.keyword;
    }
    return {
      getParam(name, value){
        let newData = $.extend({}, data);

        if (name) {
          newData[name] = value;
        }

        return '?' + $.param(newData);
      },
      set(objs) {
        for (let key in objs) {
          data[key] = objs[key];
        }

        return this;
      },
      jump: function () {
        let newData = $.extend({}, data);

        delete newData.per_page;

        router.push({path: location.pathname, query: newData});
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/unit/index.js